import { getLocale } from "../runtime";

const da_contactsupport = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kontakt support`
};

const en_contactsupport = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Contact Support`
};

const es_contactsupport = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Contactar con soporte`
};

const fi_contactsupport = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ota yhteyttä tukeen`
};

const nb_contactsupport = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kontakt kundestøtte`
};

const sv_contactsupport = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kontakta support`
};

const contactsupport = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_contactsupport(inputs)
	if (locale === "en") return en_contactsupport(inputs)
	if (locale === "es") return es_contactsupport(inputs)
	if (locale === "fi") return fi_contactsupport(inputs)
	if (locale === "nb") return nb_contactsupport(inputs)
	if (locale === "sv") return sv_contactsupport(inputs)
	return "contactSupport";
};

export { contactsupport as "contactSupport" };